import { render, staticRenderFns } from "./InvitationAccept.vue?vue&type=template&id=50d46bee&scoped=true&"
import script from "./InvitationAccept.vue?vue&type=script&lang=js&"
export * from "./InvitationAccept.vue?vue&type=script&lang=js&"
import style0 from "./InvitationAccept.vue?vue&type=style&index=0&id=50d46bee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d46bee",
  null
  
)

export default component.exports